import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Card,
  CardContent,
  Grid,
  Paper,
  Typography } from
'@mui/material';
import { DeduplicationTask } from 'crqlar-react-common/dist/models/profile/deduplicationTask.model';
import { formatDuration, formatNumber } from './deduplicationUtils';

interface SavingPhaseCardProps {
  task: DeduplicationTask;
}

const SavingPhaseCard: React.FC<SavingPhaseCardProps> = ({ task }) => {
  const { t } = useTranslation();
  if (!task.savingStats) return null;
  const stats = task.savingStats;

  return (
    <Card variant="outlined" sx={{ mb: 3, p: 2 }}>
            <CardContent>
                <Typography variant="h4" gutterBottom sx={{ fontWeight: 600 }}>{t("Step 4: Saving Results")}

        </Typography>
                <Typography variant="h6" color="text.secondary" sx={{ mb: 4 }}>{t("Duration:")}
          {formatDuration(stats.durationMs)}
                </Typography>

                <Grid container spacing={4}>
                    <Grid item xs={12} md={4}>
                        <Paper elevation={0} sx={{ bgcolor: 'background.default' }}>
                            <Typography variant="h6" color="primary" gutterBottom>{t("Clusters Saved")}

              </Typography>
                            <Typography variant="h3" sx={{ fontWeight: 700 }}>
                                {formatNumber(stats.clustersSaved)}
                            </Typography>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Paper elevation={0} sx={{ bgcolor: 'background.default' }}>
                            <Typography variant="h6" color="primary" gutterBottom>{t("Clusters Deleted")}

              </Typography>
                            <Typography variant="h3" sx={{ fontWeight: 700 }}>
                                {formatNumber(stats.clustersDeleted)}
                            </Typography>
                        </Paper>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>);

};

export default SavingPhaseCard;
